import { createAction } from '@reduxjs/toolkit';

import { IAccount, IError } from '../../interfaces';

export const resetAccount = createAction('account.reset-account');
export const resetAccountStatus = createAction('account.reset-account-status');
export const resetEditAccountStatus = createAction('account.reset-edit-account-status');

export const fetchAccount = createAction('account.fetch-account');
export const fetchAccountSucceeded = createAction<{ account: IAccount }>('account.fetch-account.succeeded');
export const fetchAccountFailed = createAction<IError>('account.fetch-account.failed');

export const editAccount = createAction<{ account: IAccount }>('account.edit-account');
export const editAccountSucceeded = createAction<{ account: IAccount }>('account.edit-account.succeeded');
export const editAccountFailed = createAction<IError>('account.edit-account.failed');
